import React from 'react';
import { classNames } from '../../utils/style';
import {
  textBody,
  textBodyUppercaseSmall,
  textCaption,
} from '../../styles/typography';
import { Image } from '../../components/Image';

import {
  animationImage,
  applyCardContentStyle,
  applyCardStyle,
  applyLogoContentStyle,
  applyTextStyle,
  transitionAnimation,
} from './logic';
import { CardProps } from '.';

export const FormCard = ({
  type,
  className,
  capsText,
  logo,
  companyDescription,
  text,
  logoPosition,
  image,
  name,
  jobPosition,
  as: Component = 'div',
  children,
}: CardProps) => {
  return (
    <Component
      className={classNames(
        'Card FormCard',
        'rounded-18 bg-neutral-1 flex gap-24',
        applyCardStyle(type),
        className
      )}
    >
      <figure className={applyCardContentStyle(type)}>
        {capsText && (
          <span className={classNames('mb-24', textBodyUppercaseSmall)}>
            {capsText}
          </span>
        )}
        {logo && logoPosition === 'content' && (
          <div className={`${applyLogoContentStyle(type)}`}>
            <Image {...logo} className="w-auto h-full" />
          </div>
        )}
        {text && (
          <blockquote className={classNames(applyTextStyle(type), 'z-10')}>
            <q style={{ quotes: "'« ' ' »'" }}>{text}</q>
          </blockquote>
        )}
        {children}
        <figcaption className="z-10">
          <div className={classNames('flex gap-16 mt-24')}>
            <div
              className={classNames(
                'hidden overflow-hidden relative sm:block rounded-6'
              )}
              style={{
                height: '60px',
                width: '60px',
              }}
            >
              {image && (
                <Image
                  {...image}
                  className={classNames(
                    'w-full h-full object-cover',
                    transitionAnimation,
                    animationImage
                  )}
                />
              )}
              <div
                className="absolute inset-0"
                style={{
                  background:
                    'linear-gradient(rgba(0, 0, 0, 0.13), rgba(0, 0, 0, 0.13))',
                }}
              />
            </div>
            <div className={classNames('flex flex-col justify-center')}>
              {name && (
                <div className={classNames('text-neutral-301', textBody)}>
                  {name}
                </div>
              )}
              {jobPosition && (
                <div className={classNames('text-neutral-301', textCaption)}>
                  {jobPosition}
                </div>
              )}
            </div>
          </div>
          {companyDescription && (
            <div
              className={classNames(
                'hidden text-neutral-301 md:block',
                textCaption
              )}
            >
              {companyDescription}
            </div>
          )}
        </figcaption>
      </figure>
    </Component>
  );
};
export default FormCard;
